import React from "react";
import { routesURL } from "@/components/urls";
import Link from "next/link";
import BreadCrumbs from "@/components/shared/bread-crumbs/BreadCrumbs";
import useTitle from "@/components/hooks/useTitle";
import Footer from "@/components/landing-page/Footer";

const Guide = () => {
  useTitle("Flamingos - Guides");
  const cards = [
    {
      title: "Start guide",
      body: "This guide outlines setting up flamingos, covering steps to upload your data, using AI to analyse data and more .",
      img: "/images/guides/start-guide-cover.png",
      link: routesURL.startGuide,
    },
    {
      title: "Data source guide",
      body: "This guide explains how to upload your data in CSV or Excel formats. It details the proper formatting requirements for your CSV or Excel files to ensure accurate analysis.",
      img: "/images/guides/data-source-guide-cover.png",
      link: routesURL.dataSourceGuide,
    },
  ];
  return (
    <>
      <div className=" mx-auto max-w-[900px] max-sm:px-6">
        <BreadCrumbs>
          <div>Guides</div>
        </BreadCrumbs>
      </div>
      <section className=" max-sm:px-6">
        <div className=" max-w-[900px] min-h-screen mx-auto py-[80px] max-sm:py-[40px] text-black">
          <div className="  text-[32px] max-sm:text-[28px] font-bold text-black  text-center">
            Guides to help you get started with flamingos
          </div>
          <div className=" mt-[50px] ">
            {cards.map((card, i) => (
              <Link key={i} href={card.link}>
                <div className=" h-[300px] max-sm:h-auto flex  max-sm:flex-col-reverse items-center gap-x-7  border hover:shadow-md  cursor-pointer rounded-lg  px-8 max-sm:px-0 py-5 max-sm:py-0 mt-8">
                  <div className=" flex-1 max-sm:px-4 max-sm:py-4">
                    <div className=" font-semibold text-[25px]">
                      {card.title}
                    </div>
                    <div className=" mt-2 text-[15px] ">{card.body}</div>
                  </div>
                  <div className=" h-full basis-[45%] ">
                    <img
                      src={card.img}
                      alt=""
                      className=" h-full w-full bg-cover rounded-xl max-sm:rounded-none"
                    />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Guide;
